var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _templateObject = _taggedTemplateLiteralLoose(["padding-left: 2em; padding-right: 2em;"], ["padding-left: 2em; padding-right: 2em;"]),
    _templateObject2 = _taggedTemplateLiteralLoose(["\n        &::after {\n          content: \"\";\n          position: absolute;\n          bottom: 1px;\n          right: 0px;\n\t  border-bottom: 80px solid ", ";\n          border-right: 0px solid transparent;\n          border-left: 230px solid transparent;\n       }\n     "], ["\n        &::after {\n          content: \"\";\n          position: absolute;\n          bottom: 1px;\n          right: 0px;\n\t  border-bottom: 80px solid ", ";\n          border-right: 0px solid transparent;\n          border-left: 230px solid transparent;\n       }\n     "]);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
import styled, { css, ThemeProvider } from "styled-components";
import { defaultTheme, media, Button } from "../index";
import { colors } from "../colors";

// Isolating alt themes to Segment since it's the only component using it.
var theme = { default: defaultTheme };
theme.alternate = { bg: "#E7E7E7", gray: "#ededed" };
theme.primary = {
  bg: colors.coreNavy,
  text: colors.white,
  headingText: colors.white
};
theme.secondary = {
  bg: "#56A7DC",
  text: colors.white,
  headingText: colors.white
};
theme.tertiary = {
  primary: colors.white,
  secondary: colors.coreNavy,
  bg: "#faa5aa",
  text: colors.white,
  headingText: colors.white,
  // Override logo styles if this theme is supplied to <Menu>
  logoText: "#faa5aa",
  logoBackground: colors.coreNavy
};
theme.strong = {
  bg: "#faa5aa",
  text: colors.white,
  headingText: colors.white
};
theme.footer = { bg: "#ededed", text: colors.coreNavy };
theme.dark = {
  bg: "#333333",
  primary: colors.white,
  text: colors.white,
  headingText: colors.white
};

var compileTheme = function compileTheme(spec) {
  return Object.assign({}, theme.default, spec);
};

var themeSpec = theme;

// Wrapping centered max-width container in an additional div so that background can be set full-width.
var Segment = function Segment(_ref) {
  var children = _ref.children,
      innerStyle = _ref.innerStyle,
      props = _objectWithoutProperties(_ref, ["children", "innerStyle"]);

  return React.createElement(
    StyledSegment,
    props,
    React.createElement(SegmentBackground, { hero: props.hero, heroColor: props.heroColor }),
    React.createElement(
      _StyledDiv,
      {
        style: innerStyle,
        _css: media.desktop(_templateObject)
      },
      children
    )
  );
};

// NOTE: for normal (non-angled) Segments we might want to skip the additional markup and set the background on StyledSegment directly.
var SegmentBackground = styled.div.withConfig({
  displayName: "Segment__SegmentBackground",
  componentId: "sc-1meu2cs-0"
})(["content:\"\";position:absolute;top:0;left:0;right:0;bottom:0;background:", ";z-index:-1;", ";"], function (props) {
  return props.theme.background;
}, function (props) {
  return props.hero && css(["", ";"], media.desktop(_templateObject2, function (props) {
    return props.heroColor ? props.heroColor : props.theme.background;
  }));
});

var StyledSegment = styled.div.withConfig({
  displayName: "Segment__StyledSegment",
  componentId: "sc-1meu2cs-1"
})(["position:relative;color:", ";font-size:", ";", ";", ";", ";"], function (props) {
  return props.theme.textStrong;
}, function (props) {
  return props.theme.fontSize;
}, function (props) {
  return props.hero && css(["padding-top:3em;"]);
}, function (props) {
  return (props.angled === "top" || props.angled === true) && css(["margin-top:32.5vw;", "::before{content:\"\";position:absolute;top:1px;border-bottom:32.5vw solid ", ";border-left:100vw solid transparent;transform:translateY(-100%);}"], SegmentBackground, props.theme.background);
}, function (props) {
  return (props.angled === "bottom" || props.angled === true) && css(["margin-bottom:32.5vw;", "::after{content:\"\";position:absolute;bottom:1px;border-top:32.5vw solid ", ";border-right:100vw solid transparent;transform:translateY(100%);}"], SegmentBackground, props.theme.background);
});

// const SegmentContainer = styled.div`
//   position: relative;
//   margin: auto;
//   max-width: ${props => props.theme.width};
//   padding: 1.5em;
//   ${media.desktop`padding-left: 2em; padding-right: 2em;`};

//   span + ${Button} {
//     margin-top: 1em;
//   }
// `;

// Outer wrapper to allow theming and overrides.
export default (function (_ref2) {
  var theme = _ref2.theme,
      _ref2$themeOverride = _ref2.themeOverride,
      themeOverride = _ref2$themeOverride === undefined ? {} : _ref2$themeOverride,
      props = _objectWithoutProperties(_ref2, ["theme", "themeOverride"]);

  if (theme) {
    var compiledTheme = void 0;
    switch (typeof theme === "undefined" ? "undefined" : _typeof(theme)) {
      case "string":
        compiledTheme = compileTheme(themeSpec[theme]);
        break;
      case "object":
        compiledTheme = compileTheme(theme, theme);
        break;
      default:
        throw new Error("Segment: unknown theme type " + (typeof theme === "undefined" ? "undefined" : _typeof(theme)));
    }
    compiledTheme = Object.assign(compiledTheme, themeOverride);
    return React.createElement(
      ThemeProvider,
      { theme: compiledTheme },
      React.createElement(Segment, props)
    );
  } else {
    return React.createElement(Segment, props);
  }
});

var _StyledDiv = styled.div.withConfig({
  displayName: "Segment___StyledDiv",
  componentId: "sc-1meu2cs-2"
})(["position:relative;margin:auto;max-width:", ";padding:1.5em;", ";span + ", "{margin-top:1em;}"], function (props) {
  return props.theme.width;
}, function (p) {
  return p._css;
}, Button);